import React from 'react';
import { LineChart, Line, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import Colors from '../../library/Colors';
import StatsSectionHeader from './StatsSectionHeader';
import { axisDate, belgianDates } from './dateFormat';

const PALETTE = [Colors.sft_blue, '#3cb44b', '#800000', '#9A6324', '#911eb4', '#f58231', '#469990'];

/**
 * Renders one series spec from the backend:
 *   {key, label, description?, granularity: 'day'|'month', rows: [{day, ...}], lines: [{key, label}], sql?}
 * Day granularity → lines; month granularity → grouped bars.
 */
export default function StatsSeriesChart({ series, theme, height = 300, showSql = false, t }) {
  if (!series) return null;
  const rows = series.rows || [];
  const lines = series.lines || [];
  const margin = { top: 5, right: 30, left: 20, bottom: 5 };
  const isCategory = series.granularity === 'category';
  const isMonth = series.granularity === 'month' || isCategory;
  const tickFormatter = (d) => (isCategory ? d : axisDate(d));
  const labelFormatter = (d) => (isCategory ? d : belgianDates(String(d)));

  return (
    <div style={{ width: '100%', minWidth: 0, display: 'flex', flexDirection: 'column', flex: '1 1 auto' }}>
      <StatsSectionHeader label={series.label} description={series.description} sql={series.sql} showSql={showSql} theme={theme} t={t} />
      {rows.length === 0 ? (
        <p style={{ opacity: 0.7, padding: '4px 12px' }}>–</p>
      ) : (
        <div style={{ width: '100%', minHeight: height, flex: '1 1 auto', overflow: 'hidden' }}>
          <ResponsiveContainer width="100%" height="100%">
            {isMonth ? (
              <BarChart data={rows} margin={margin}>
                <Legend verticalAlign="top" height={36} />
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="day" tickFormatter={tickFormatter} />
                <YAxis />
                <Tooltip labelFormatter={labelFormatter} />
                {lines.map((l, i) => <Bar key={l.key} dataKey={l.key} name={l.label} fill={PALETTE[i % PALETTE.length]} />)}
              </BarChart>
            ) : (
              <LineChart data={rows} margin={margin}>
                <Legend verticalAlign="top" height={36} />
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="day" tickFormatter={tickFormatter} />
                <YAxis />
                <Tooltip labelFormatter={labelFormatter} />
                {lines.map((l, i) => <Line key={l.key} type="monotone" dataKey={l.key} name={l.label} stroke={PALETTE[i % PALETTE.length]} dot={rows.length <= 62} activeDot={{ r: 6 }} />)}
              </LineChart>
            )}
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
